import { ApiMetadata } from "./ApiMetadata";
import { Collection } from "../Collection";
import { Logger } from "../logging/Logger";
import { LogManager } from "../logging/LogManager";

export class ApiMetadataCache {
    private static readonly cache: Collection<ApiMetadata> = {};
    private static log: Logger;
    
    public static get(endpoint: string) : ApiMetadata {
        return this.cache[endpoint];
    }

    public static isCached(endpoint: string): boolean {
        return this.get(endpoint) != null;
    }

    public static put(endpoint: string, metadata: ApiMetadata) {
        this.getLog().debug("Putting metadata for endpoint %s into cache: %o", endpoint, metadata);
        this.cache[endpoint] = metadata;
    }

    public static putAll(otherCache: Collection<ApiMetadata>) {
        if (otherCache != null) {
            for (const endpoint of Object.keys(otherCache)) {
                const value = otherCache[endpoint];
                this.getLog().debug("Putting metadata for endpoint %s into cache (from existing cache): %o", endpoint, value);
                this.put(endpoint, value);
            }
        }
    }

    public static clear(endpoint: string) {
        this.getLog().debug("Clearing cached metadata for endpoint: %s", endpoint);
        delete this.cache[endpoint];
    }

    public static clearAll() {
        this.getLog().debug("Clearing all cached endpoint metadata");
        for (const name of Object.keys(this.cache)) {
            delete this.cache[name];
        }
    }

    public static getCopy(): Collection<ApiMetadata> {
        return { ...this.cache };
    }

    public static isEmpty(): boolean {
        return Object.keys(this.cache).length === 0;
    }

    private static getLog(): Logger {
        if (this.log == null) {
            this.log = LogManager.getLogger("core.ApiMetadataCache");
        }
        return this.log;
    }
}
